import axiosHttpRequest from "../axios";

async function searchRakeMasterListService(
  endpoint,
  queryparams,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );

  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewDataObj = {};
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewInfo;
}

async function saveRakeMaintenanceService(endpoint, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    postdata,
    configheaders
  );
  return serviceResponse;
}

async function getRakeInductionDetailsService(
  endpoint,
  queryparams,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );

  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }

  return listViewData;
}

export default {
  searchRakeMasterListService,
  saveRakeMaintenanceService,
  getRakeInductionDetailsService,
};
